module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgB7VNRDcIwEL2hAAmVMAcgYQ6ohDlgDhgKhgOCAiSAg81BcVCuybusWdqst0/CS14u6/Ve27s3op+A994wL8yR+WLemQ1tBRefmM6ncSYtcEMR7PG9Z1rcOqDVig4o7BK5GjlHGqB/AWZLfpfR3SN+MnlZNxrRCbFeJkJvI7E3lYILj3jeGD8Rw5J+D6QFF90iCz0h5lKHlQoaCOUQRK1WcBTbBFsxG7SkXRy2/hMsBHsMJbXPRq1o1kSH0iH4eZgud7hMVmCoAFErbLwe+1Q8+aiqaqIyXBEPOVGDWG7oea9JZvH8ziv9h5qa/hB8Aee9gcTRKkN0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/icon-username.png
// module id = IoEo
// module chunks = 0